import { render, staticRenderFns } from "./ReportBugModal.vue?vue&type=template&id=6d08ede7&"
import script from "./ReportBugModal.vue?vue&type=script&lang=ts&"
export * from "./ReportBugModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports